module.exports = __webpack_public_path__ + "static/media/IMG_8284.614a3512.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/IMG_8284.JPG
// module id = 320
// module chunks = 0